import { ThemeConfig } from 'antd';

export const theme = {
  token: {
    colorPrimary: '#1a6cf0',
    colorInfo: '#1a6cf0',
    colorSuccess: '#0f9f6e',
    colorWarning: '#d97706',
    colorError: '#dc2626',
    colorBgBase: '#f4f6f9',
    colorTextBase: '#1a2332',
    colorBorder: '#d8dee8',
    borderRadius: 10,
    fontFamily:
      '"Plus Jakarta Sans", "Noto Sans SC", "PingFang SC", "Microsoft YaHei", sans-serif',
    fontSize: 14,
  },
  components: {
    Button: {
      borderRadius: 10,
      controlHeight: 40,
    },
    Input: {
      controlHeight: 40,
      activeBorderColor: '#1a6cf0',
    },
    Modal: {
      borderRadiusLG: 14,
      contentBg: '#ffffff',
      headerBg: '#ffffff',
    },
    Table: {
      headerBg: '#f0f3f8',
      rowHoverBg: '#f5f8fc',
      borderColor: '#e6ebf2',
    },
    Layout: {
      bodyBg: '#f4f6f9',
      headerBg: '#ffffff',
      siderBg: '#0f1724',
    },
    Menu: {
      darkItemBg: '#0f1724',
      darkSubMenuItemBg: '#0f1724',
      darkItemSelectedBg: 'rgba(26, 108, 240, 0.22)',
      darkItemSelectedColor: '#ffffff',
    },
    Form: {
      labelColor: '#5b6577',
    },
  },
} as ThemeConfig;

export default theme;
